export enum OrderByOptions {
  ItemName = 'Item Name',
  VendorItemName = 'Vendor Item Name',
  LineItemNumber = 'Line Item Number',
}
